<template>
    <div class="home">
        <goTop/>
        <KV/><!-- 主視覺 -->
        <div class="gradient"><!-- 跨區域漸層背景 -->
            <Intro/>
            <Assure/>
        </div>
        <travelTheme/>
        <school/>
        <qa/>
    </div>
</template>

<script setup>
// @ is an alias to /src
    import goTop from "@/components/gotop.vue";
    import KV from "@/components/home/kv.vue";
    import Intro from "@/components/home/intro.vue";
    import Assure from "@/components/home/assure.vue";
    import travelTheme from "@/components/home/travelTheme.vue";
    import school from "@/components/home/school.vue";
    import qa from "@/components/home/qa.vue";
    import {popUp} from "@/utils/popUp";
    import gtm from "@/utils/gtmDataLayer"
    import {useRoute} from "vue-router";
    import {onMounted} from "vue";

    console.log('taiwan : 2.0.0 20240729');
    const route = useRoute();
    if(route.query.referrerCode){
        sessionStorage.setItem('referrerCode', route.query.referrerCode);
    }
    if(route.query.tag){
        sessionStorage.setItem('trackingCode', route.query.tag);
    }

onMounted(()=>{
        popUp();//公告系統
        gtm.pageViewEvent();//新增pageViewEvent
    })

</script>